export const logsColors = {
  INFO: "#d6d6d6",
  DEBUG: "#666666",
  ERROR: "red",
  FATAL: "red",
  WARN: "yellow",
}
